<template>
  <Card :name="config.variableFullName">
    <template v-slot:header>
      <h5 class="card-category">
        {{ config.variableFullName }}
      </h5>

      <h3 class="card-title">
        <i
          class="fa"
          :class="[config.icon, getIconColorClass()]"
          aria-hidden="true"
          style="font-size: 30px; margin-right: 10px"
        >
        </i>
        <span>
          {{ value }} {{ config.unit }} ({{ waterInPercent }}% )
        </span>
      </h3>
    </template>
    <div class="water-level-widget">
      <div class="tank">
        <div
          class="water"
          :style="{
            height: waterLevelPercent + '%',
            backgroundColor: updateColorClass(),
          }"
        ></div>
        <div class="percentage-display" v-if="waterLevelPercent > 0">
          <div>{{ value }} {{ config.unit }}</div>
          <div class="">( {{ waterLevelPercent }} % )</div>
        </div>

        <div class="liters-display mt-2" v-if="waterLevelPercent > 0">
          {{ config.maxValue }} {{ config.unit }}
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import emitter from "@/eventBus"
export default {
  props: ["config"],
  data() {
    return {
      value:0,
      waterLevelPercent: 0, // Nivel de agua inicial en %
    };
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          emitter.off(this.topic + "/sdata");
          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt) {
            variable = this.config.variableFullName;
          }
          if (this.config.demo){
            this.value = this.config.maxValue * 0.61
          }
          //userId/dId/uniquestr/sdata
          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;

          emitter.on(this.topic + "/sdata", this.processReceivedData);
        }, 300);
      },
    },
  },
  computed: {
    waterInPercent() {
      // Calcula la cantidad de agua en litros en base al nivel de agua
      this.waterLevelPercent = ((this.value / this.config.maxValue) * 100).toFixed(this.config.decimalPlaces);    
      return this.waterLevelPercent
    },
  },
  methods: {
    processReceivedData(data) {
      try {
        this.value = data.value;
      } catch (error) {
        console.log(error);
      }
    },
    updateColorClass() {
      var c = this.config.class;
      if (c == "success") {
        return "#7cae47";
      }
      if (c == "primary") {
        return "#4380dd";
      }
      if (c == "warning") {
        return "#e69f17";
      }
      if (c == "danger") {
        return "#e04f1a";
      }
    },
    getIconColorClass() {
      if (!this.value) {
        return "text-dark";
      }

      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    },
    increasewaterLevelPercent() {
      if (this.waterLevelPercent < 100) {
        this.waterLevelPercent += 10; // Aumentar el nivel de agua
      }
    },
    decreasewaterLevelPercent() {
      if (this.waterLevelPercent > 0) {
        this.waterLevelPercent -= 10; // Disminuir el nivel de agua
      }
    },
  },
};
</script>

<style scoped>
.percentage-display {
  position: absolute;
  bottom: calc(
    100% - (waterLevelPercent * 3)
  ); /* Ajustar la posición del texto según el nivel de agua */
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  font-size: 1.2rem;
  color: rgb(39, 38, 38);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  margin-top: 7em;
}

.liters-display {
  position: absolute;
  bottom: calc(
    100% - (waterLevelPercent * 3) + 20px
  ); /* Ajustar la posición del texto según el nivel de agua */
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  font-size: 1.2rem;
  color: rgb(39, 38, 38);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.water-level-widget {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Arial", sans-serif;
}

.tank {
  width: 250px;
  height: 300px;
  border: 4px solid #007bff;
  border-radius: 10px;
  position: relative;
  background-color: #f0f0f0;
  box-shadow: 0 4px 20px rgba(0, 123, 255, 0.2);
  overflow: hidden;
}

.water {
  position: absolute;
  bottom: 0;
  width: 100%;
  transition: height 0.5s ease;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
}

.level-display {
  margin-top: 15px;
  font-weight: bold;
  font-size: 1.5rem;
  color: #333;
}

.controls {
  margin-top: 10px;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #0056b3;
}
</style>
